import PlayerAsset from './PlayerAsset';

declare global {
    interface Window { assetCache: any; }
}
window.assetCache = window.assetCache || [];

export default class PlayerAssets {
  private static getFromCache(url:string):PlayerAsset|null {
    const asset = window.assetCache.filter((a:PlayerAsset) => {
      return a.url === url;
    })[0];
    return asset ?? null;
  }

  private static async create(url:string):Promise<PlayerAsset> {
    const response = await fetch(url);
    const blob = await response.blob();
    const asset = new PlayerAsset({url, blob});
    window.assetCache.push(asset);
    return asset;
  }

  static async get(url:string):Promise<PlayerAsset> {
    const cachedAsset = PlayerAssets.getFromCache(url);
    return cachedAsset ?? PlayerAssets.create(url);
  }
}
